<template>
	<div>
		<van-nav-bar title="登录" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" />

		<van-form @submit="onSubmit">
			<van-cell-group title="账号密码登录">
				<van-field v-model="account" name="account" label="账号" placeholder="微信号/手机号" :rules="[{ required: true, message: '请填写微信号' }]" />
				<van-field v-model="password" name="password" label="密码" type="password" placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
			</van-cell-group>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					开始登陆
				</van-button>
			</div>
		</van-form>

		<van-popup v-model="showWebView" position="top" :style="{ height: '60%', width: '100%', background: 'rgba(0,0,0,0)' }">
			<iframe @load="iframeLoad" style="overflow：hidden;background: #ffffff;" frameborder=0 name="webview" scrolling=no :src="url" width="100%"
			 height="90%"></iframe>
			<div v-show="showOK" style="margin: 0 auto;text-align: center;color: #000;width: 100%;height: .39rem;line-height: .39rem;background: #fff;" @click="goLogin">完成验证后请点击这里</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		NavBar,
		Popup,
		CellGroup
	} from 'vant';

	Vue.use(CellGroup);
	Vue.use(NavBar);
	Vue.use(Popup);

	var loadNumber = 0;
	export default {
		data() {
			return {
				password: '',
				account: '',
				url: '',
				showWebView: false,
				showOK: false
			}
		},
		mounted() {
			this.$dialog.confirm({
				title: '警告',
				message: '使用该方式登录会导致手机上的微信退出',
				confirmButtonText: '我已知晓',
				cancelButtonText: '考虑一下'
			}).then(() => {

			}).catch(() => {
				this.$router.push('/member-center')
			})
		},
		methods: {
			goLogin(){
				this.showWebView = false
				this.url = ''
				this.showOK = false
				this.$dialog.alert({
					message: '如果您已经完成安全验证，请再次点击“开始登录”按钮完成登录'
				}).then(() => {
					loadNumber = 0
				})
			},
			iframeLoad(e) {
				loadNumber++
				// console.log(e)
				var src = e.path[0].src
				if (loadNumber > 1) {
					if (src.indexOf('w_tcaptcha') != -1) {
						this.showWebView = false
						this.url = ''
						this.showOK = false
						this.$dialog.alert({
							message: '如果您已经完成安全验证，请再次点击“开始登录”按钮完成登录'
						}).then(() => {
							loadNumber = 0
						})
					}else{
						this.showOK = true
					}
				}

			},
			onClickLeft() {
				this.$router.go(-1)
			},
			onSubmit(e) {
				this.$ApiUtil.Account.passwordLogin({
					account: e.account,
					password: e.password
				}).then((res) => {
					console.log(res)
					var url = '';
					if (!res.status) {
						if (typeof res.url != 'undefined') {

							this.url = res.url
							this.$dialog.alert({
								message: res.message
							}).then(() => {
								this.showWebView = true
							})
							return

						}
						this.$dialog.alert({
							message: res.message
						}).then(() => {})
					} else {
						this.$dialog.alert({
							message: res.message
						}).then(() => {
							this.$router.push('/member-center')
						})
					}
				})
			}
		}
	}
</script>

<style>
</style>
